var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/path.js
// module id = 122
// module chunks = 1